import { Injectable } from '@angular/core';
import { URLSearchParams, Http } from "@angular/http";
import {Observable} from  "rxjs/Observable";
import { HttpService } from './http-service';
import 'rxjs/add/operator/map';
import {LoadingService} from "./loading-service";
import {AuthStore} from '../stores/auth-store';

/*
  Generated class for the HttpReserveProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class HttpStaffProvider extends HttpService{

  constructor(protected http: Http, protected loadingService:LoadingService, protected authStore:AuthStore) {
  	super(http, loadingService, authStore);
  }

  /**
   * 同意書文言登録
   */
  getSignMessage(): Observable<any> {
    let userParam = new URLSearchParams();
    userParam.set("api", "/staffs/getSignMessage");
    var options = super.buildParam(userParam);

    return super.get(options);
  }
}



// WEBPACK FOOTER //
// ./src/providers/http-staff.ts